<template>
    <b-form-group
        :id="name"
        :label="label"
        :label-for="name">
        <b-form-select v-model="selectValue" :options="options"></b-form-select>
    </b-form-group>
</template>

<script>

export default {
    name: 'select',
    props: ['placeholder', 'meta', 'label', 'name', 'value'],
    data() {
        return {
            selectValue: this.value ? this.value : null
        };
    },
    methods: {
        updateField: function (currentState) {
            this.$emit('input', currentState);
        }
    },
    computed: {
        options: function() {
            return this.meta.split(',').map(value => {
                return {
                    value: value.trim(),
                    text: value.trim()
                }
            });
        },
    },
    watch: {
        value: function (newValue) {
            this.selectValue = newValue;
        },
        selectValue: {
            handler(val) {
                this.$emit('input', val);
            },
            deep: true
        }
    },
}

</script>